
const getSelectedText = (el, length) => {
    /* eslint-disable no-undef */
    const isIOS = navigator.userAgent.match(/ipad|ipod|iphone/i);
    if (isIOS) {
        const range = document.createRange();
        range.selectNodeContents(el);

        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        el.setSelectionRange(0, length);
    }
    else el.select();
    /* eslint-enable no-undef */
};

const copy = copyText => {
    /* eslint-disable no-undef */
    const el = document.createElement('textarea');
    el.value = copyText;
    el.setAttribute('readonly', '');

    document.body.appendChild(el);
    getSelectedText(el, copyText.length);

    const success = document.execCommand('copy');
    document.body.removeChild(el);
    return success;
    /* eslint-enable no-undef */
};

export {
    copy
};
